import reducer from "./reducers";

import * as colegiosOps from "./operations";
import * as colegiosTypes from "./types";

export { colegiosOps, colegiosTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/colegios/index.js